import styles from "@/styles/Video.module.scss";
import OpenAppButton from "./OpenAppButton";
import AndroidAppDownloadBanner from "./AndroidAppDownloadBanner";
import IOSAppDownloadBanner from "./IOSAppDownloadBanner";
import { useCallback } from "react";

export default function SuggestApp({watch, state}) {
  const handleClick = useCallback(() => {
    state.standWatchOnBrowserFlag();
  }, []);

  return (
    <div className={styles.suggestApp}>
      <OpenAppButton watch={watch} />
      <div className={styles["app-download-banner"]}>
        <IOSAppDownloadBanner />
        <AndroidAppDownloadBanner />
      </div>
      <div className={styles["watchOnBrowserLink"]}>
        <a className="accentColor underline" onClick={handleClick}>ブラウザで視聴する</a>
      </div>
    </div>
  );
}